var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mr-3",attrs:{"small":"","loading":_vm.loading},on:{"click":_vm.handler}},[_vm._v("Update Stripe PI")])
}
var staticRenderFns = []

export { render, staticRenderFns }